const loadedDependency = {};

const existingDependency = name => {
  return name in loadedDependency ? loadedDependency[name] : false;
};

const saveDependency = (name, lib) => {
  return new Promise((resolve, reject) => {
    try {
      if (!existingDependency(name)) {
        loadedDependency[name] = lib;
        resolve(false);
      } else {
        resolve(true);
      }
    } catch (e) {
      reject(e);
    }
  });
};

/**
 * This utility class is injected in all components that extends Component
 * and is used to lazy load third-part libraries
 */
export default class DependencyInjector {
  static get CUSTOM_STYLES() {
    return '../../../stylesheets';
  }

  static defaultCatchPromise(error) {
    console.error('Failed to inject dependency', error.stack);
  }

  /**
   * Log utility
   * @param logStr
   */
  log(logStr = '') {
    if (logStr != '') {
      let myName = this.constructor.name;
      console.debug(`[${myName}] ${logStr}`);
    }
  }

  // loadAos(thenPromise, catchPromise) {
  //   this.log('Loading aos');

  //   import(/* webpackChunkName: `aos` */  'aos/dist/aos.css').then(
  //     () => {
  //       import(/* webpackChunkName: `aos` */ 'aos').then(thenPromise).catch(catchPromise);
  //     }).catch(catchPromise);
  // }

  loadModalAndExecute(thenPromise, catchPromise) {
    this.log('Loading Modal');
    if (existingDependency('vex'))
      return thenPromise(existingDependency('vex'));

    import(/* webpackChunkName: `vex` */ 'vex-js/dist/js/vex.js')
      .then(res => {
        saveDependency('vex', res);
        thenPromise(res);
      })
      .catch(catchPromise);
  }
  /**
   * Load all jquery ui js (1.5kb gzipped)
   * @param widgetName the name of jquery wigget
   * @param thenPromise the code that must be executed when the widget is ready
   * @param catchPromise the code that must be executed when the widget fails to load
   */
  loadJqueryUIWidgetAndExecute(widgetName, thenPromise, catchPromise) {
    this.log(`Loading jQuery UI dist for ${widgetName}`);

    import(
      /* webpackChunkName: `jquery-ui` */
      'jquery-ui-dist/jquery-ui').then(thenPromise).catch(catchPromise);
  }
  
  loadCarouselAndExecute(thenPromise, catchPromise) {
    this.log('Loading Slick Carousel');
    if (existingDependency('carousel'))
      return thenPromise(existingDependency('carousel'));
    import(/* webpackChunkName: `slick-carousel` */ 'slick-carousel/slick/slick.js')
      .then(res => {
        saveDependency('carousel', res);
        thenPromise(res);
      })
      .catch(catchPromise);
  }

  loadSelect2AndExecute(thenPromise, catchPromise) {
    this.log('Loading Select2');
    if (existingDependency('select2'))
      return thenPromise(existingDependency('select2'));
    import(/* webpackChunkName: `select2` */ 'select2/dist/js/select2.min.js')
      .then(res => {
        saveDependency('select2', res);
        thenPromise(res);
      })
      .catch(catchPromise);
  }

  loadStickyAndExecute(thenPromise, catchPromise) {
    this.log('Loading stickybits');
    import(/* webpackChunkName: `stickybits` */ 'stickybits')
      .then(thenPromise)
      .catch(catchPromise);
  }

  loadFlatpickrLocale(locale, thenPromise, catchPromise) {
    import(/* webpackChunkName: `flatpickr-locale` */ `flatpickr/dist/l10n/${locale}.js`)
      .then(thenPromise)
      .catch(catchPromise);
  }

  loadFlatpickr(thenPromise, catchPromise) {
    this.log('Loading Flatpickr');

    import(/* webpackChunkName: `flatpickr` */ 'flatpickr/src/style/flatpickr.styl')
      .then(() => {
        import(/* webpackChunkName: `flatpickr` */ 'flatpickr/src/style/themes/airbnb.styl');
        import(/* webpackChunkName: `flatpickr` */ 'flatpickr/dist/flatpickr.js')
          .then(thenPromise)
          .catch(catchPromise); // js library
      })
      .catch(catchPromise);
  }

  /**
   * This method load the query-string library and execute the given promises
   * when loaded
   * @param thenPromise the code that must be executed when jscroll is ready
   * @param catchPromise the code that must be executed when jscrol fails to load
   */
  // loadQueryStringAndExecute(thenPromise, catchPromise) {
  //   this.log("Loading query-string");
  //   import(/* webpackChunkName: `query-string` */ "query-string").then(thenPromise).catch(catchPromise);
  // }

  /**
   * This method load the jscroll library and execute the given promises
   * when loaded
   * @param thenPromise the code that must be executed when jscroll is ready
   * @param catchPromise the code that must be executed when jscroll fails to load
   */
  // loadJscrollAndExecute(thenPromise, catchPromise) {
  //   this.log("Loading jscroll");
  //   import(/* webpackChunkName: `jscroll` */ "jscroll").then(thenPromise).catch(catchPromise);
  // }

  /**
   * This method load the blueimp-file-upload library and execute the given promises
   * when loaded
   * @param thenPromise the code that must be executed when blueimp-file-upload is ready
   * @param catchPromise the code that must be executed when blueimp-file-upload fails to load
   */
  // loadBlueimpFileUploadAndExecute(thenPromise, catchPromise) {
  //   this.log("Loading BlueimpFileUpload");
  //   import(/* webpackChunkName: `blueimp-file-upload` */ "blueimp-file-upload").then(
  //       () => {
  //         import(/* webpackChunkName: `blueimp-file-upload` */ 'blueimp-file-upload/css/jquery.fileupload.css').then(thenPromise).catch(catchPromise); // js library
  //     }).catch(catchPromise);
  // }

  loadJqueryValidationAndExecute(thenPromise, catchPromise) {
    this.log('Loading jquery-validation');
    import(/* webpackChunkName: `jquery-validation` */ 'jquery-validation')
      .then(thenPromise)
      .catch(catchPromise);
  }

  loadSimpleBarAndExecute(thenPromise, catchPromise) {
    this.log('Loading SimpleBar');
    if (existingDependency('simplebar'))
      return thenPromise(existingDependency('simplebar'));
    import(/* webpackChunkName: `simplebar` */ 'simplebar')
      .then(res => {
        saveDependency('simplebar', res);
        thenPromise(res);
      })
      .catch(catchPromise);
  }

  loadExternalScript(url) {
    return new Promise((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.addEventListener('load', () => resolve(script), false);
      script.addEventListener('error', () => reject(script), false);
      document.body.appendChild(script);
    });
  }
}
